import React from 'react';

export const resolveComponentWithProps = (component, props) => {
  if (typeof component === 'function') {
    return component(props);
  }
  return React.cloneElement(component, props);
};
